exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){.reject-modal .modal-dialog{overflow:auto;width:580px;height:auto}}@media (max-width:768px){.reject-modal .modal-dialog{position:absolute;width:100vw;height:100vh;margin:0}.reject-modal .modal-dialog .modal-content{border:none;box-shadow:none}.reject-modal .modal-dialog .modal-content a.other-reason,.reject-modal .modal-dialog .modal-content a.yes-mail{font-size:16px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/acceptRejectApplication/rejectApplication/rejectApplicationModal/rejectApplicationModal.css
// module id = 494
// module chunks = 0